module.exports = __webpack_public_path__ + "static/img/evan.a5847ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success-stories/evan.jpg
// module id = Inlf
// module chunks = 0